import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Col, Glyphicon, Row} from "react-bootstrap";
import {Link} from 'react-router-dom';
import {loadGeneralEnum} from '../actions/enums';
import {countWalks, loadWalks, updateWalkStatus} from '../actions/walks';
import {showModal} from "../actions/modal";
import {resetPage, showMessage} from '../actions';
import {defaultState} from '../reducers/paginate';
import Walks from '../components/walk/Walks';
import {breadcrumbs} from "../utils";

class WalksPage extends Component {

	constructor(props) {
		super(props);

		this.handleFetchData = this.handleFetchData.bind(this);
		this.handleFetchEnums = this.handleFetchEnums.bind(this);
	}

	componentWillMount() {
	}

	componentWillReceiveProps(nextProps) {
	}

	componentWillUnmount() {
		this.props.resetPage();
	}

	handleFetchEnums(enums, filter = {}) {
		for (const i in enums) {
			if (enums.hasOwnProperty(i)) {
				this.props.loadGeneralEnum(enums[i], filter)
			}
		}
	}

	handleFetchData(filter) {
		this.props.loadWalks(filter);
		this.props.countWalks(filter);
	}

	render() {
		const {page, enums, session} = this.props;

		return (
			<div>
				<Row>
					<Col xs={8}>
						{breadcrumbs([{title: 'Vycházky'}])}
					</Col>
					<Col xs={4}>
						<Link to={{pathname: "/vychazky/nova"}} className="btn btn-success pull-right"><Glyphicon glyph="plus"/> Nová vycházka</Link>
					</Col>
				</Row>
				<Walks {...page} enums={enums} session={session}
					onFetchEnums={this.handleFetchEnums}
					onFetchData={this.handleFetchData}
					onUpdateWalkStatus={this.props.updateWalkStatus}
					onShowModal={this.props.showModal}
					onShowMessage={this.props.showMessage}
				/>
			</div>
		)
	}
}

WalksPage.propTypes = {
	page: PropTypes.object,
	enums: PropTypes.object,
	loadGeneralEnum: PropTypes.func.isRequired,
	loadWalks: PropTypes.func.isRequired,
	countWalks: PropTypes.func.isRequired,
	updateWalkStatus: PropTypes.func.isRequired,
	showMessage: PropTypes.func.isRequired,
	resetPage: PropTypes.func.isRequired,
	session: PropTypes.object.isRequired,
	showModal: PropTypes.func.isRequired
};


const mapStateToProps = (state, ownProps) => {
	const {
		pagination: {walks},
		enums,
		session
	} = state;

	const page = walks[0] || defaultState;

	return {
		page,
		enums,
		session
	}
};

export default connect(mapStateToProps, {
	loadGeneralEnum,
	loadWalks,
	countWalks,
	updateWalkStatus,
	showMessage,
	resetPage,
	showModal
})(WalksPage)


// WEBPACK FOOTER //
// ./src/containers/WalksPage.js